<div class="form-horizontal">
    <div class="form-group">
      <label class="col-md-2 control-label">Apellido paterno:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Apellido paterno</mat-label>
          <input
            matInput
            type="text"
            placeholder="apellido paterno"
            [(ngModel)]="persona.apellidoPaterno"
            [disabled]="disabled"
          />
        </mat-form-field>
      </div>
      <label class="col-md-2 control-label">Apellido materno:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Apellido materno</mat-label>
          <input
            matInput
            type="text"
            placeholder="apellido materno"
            [(ngModel)]="persona.apellidoMaterno"
            [disabled]="disabled"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-2 control-label">Nombres:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Nombres</mat-label>
          <input
            matInput
            type="text"
            placeholder="nombres"
            [(ngModel)]="persona.nombres"
            [disabled]="disabled"
          />
        </mat-form-field>
      </div>
      <label class="col-md-2 control-label">DNI:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>DNI</mat-label>
          <input
            matInput
            type="text"
            placeholder="DNI"
            [(ngModel)]="persona.nroDocumentoIdentidad"
            [disabled]="disabled"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-2 control-label">Cargo:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Cargo</mat-label>
          <input
            matInput
            type="text"
            placeholder="cargo"
            [(ngModel)]="persona.cargo"
            [disabled]="disabled"
          />
        </mat-form-field>
      </div><label class="col-md-2 control-label">Correo:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Correo</mat-label>
          <input matInput type="text" placeholder="correo" [(ngModel)]="persona.correo" [disabled]="disabled" name="correo"
          />
        </mat-form-field>
      </div>  
    </div>
  </div>